import {createContext} from "react";

// it could be a good idea to put this in a "IndexContext"
export const SidebarContext = createContext({
    currentMemberAuthorizations: null,
    currentMember: null,
    currentInventory: null,
    currentOrganization: null,
    memberOrganizations: [],
    isMobile: false,
    memberInventories: [],
    setCurrentInventory: (inventory) => {},
    organizationApplications: {},
    selectedApplication : null,
    stripeLink: null,
    headerHeight: null,
    openBottomDrawer: () => {},
    closeBottomDrawer: () => {},
    setSelectedApplication: (application) => {},
    currentPath: null,
    currentFullPath: null,
    isSidebarOpen: false,
    closeSidebar: () => {},
    setOpenSidebar: () => {},
    isUserAdmin: false,
    selectedRetailer: null
})
